module.exports = __webpack_public_path__ + "static/media/red-upload.3b530c55.png";